module.exports = __webpack_public_path__ + "img/client-13.377994c7.png";